import axios from 'axios'

/**
 * 郵便番号サービス
 */
export default class ZipService {
    /** インスタンス */
    private static _instance: ZipService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new ZipService();
        }
        return this._instance;
    }

    /**
     * 郵便番号から住所を取得
     */
    public async getAddress(zipCode: string): Promise<string> {
        return await axios.get(`/api/zip?zipcode=${zipCode}`)
            .then((results) => {
                if (results.status === 200) {
                    return results.data.data.fullAddress
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
